import { render, staticRenderFns } from "./RelationEdit.vue?vue&type=template&id=74a7aa02&scoped=true"
import script from "./RelationEdit.vue?vue&type=script&lang=js"
export * from "./RelationEdit.vue?vue&type=script&lang=js"
import style0 from "./RelationEdit.vue?vue&type=style&index=0&id=74a7aa02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a7aa02",
  null
  
)

export default component.exports